<template>
  <header class="site-nav fixed w-full">
    <div class="nav-inner px-6">
    <router-link :to="{ name: 'home', params: { lang: currentLang } }" class="nav-logo">
      <IconLink
        name="grslash"
        :viewBox="'0 0 77.63 73.23'"
        :style="'main-logo flex-row justify-left w-8 md:w-14'"
      />
      <span class="nav-logo__text">Saul Verde</span>
    </router-link>
    <!-- <MenuMobileBtn
      @click="menuModal"
      :active="mobileMenuOpen"
      class="lg:hidden z-30"
    /> -->
    <div class="nav-controls flex">
      <nav class="flex flex-row w-fit justify-end items-center">
        <NavLinks :links="navItems" :style="desktopStyle"/>
      </nav>
      <!-- <LangSwitcher class="mx-4" /> -->
      <ThemeSwitcher />
    </div>
    <!-- <MenuAside v-show="mobileMenuOpen" :active="mobileMenuOpen" class="z-20" :style="menuMenuStyle" />
    <transition name="slide-blur">
      <div
        v-show="mobileMenuOpen"
        class="overlay-blur lg:hidden"
        aria-hidden="true"
        @click="menuModal"
      ></div>
    </transition> -->
    </div>
  </header>
</template>

<script>
import NavLinks from "./navLinks";
import IconLink from "./iconDisplay";
// import LangSwitcher from "./langSwitcher";
import ThemeSwitcher from "./themeSwitcher";
// import MenuMobileBtn from "./menuMobileBtn";
// import MenuAside from "./menuAside";
import { useRouter, useRoute } from "vue-router";
import { ref, computed } from "vue";

export default {
  name: "NavBar",
  emits: ["switcher"],
  components: {
    NavLinks,
    // LangSwitcher,
    ThemeSwitcher,
    IconLink,
    // MenuMobileBtn,
    // MenuAside,
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const currentLang = computed(() => route.params.lang || 'en');
    const navItems = [
      // { path: "home" },
      { path: "about" },
    ];

    // Only desktop: Aligns menu items in a single row
    const desktopStyle = "flex flex-row mx-2";

    // Only mobile menu: makes menu items larger
    const menuMenuStyle = "text-2xl";

    let mobileMenuOpen = ref(false);

    const menuModal = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value;
      context.emit("switcher");
    };

    // Close menu aside after route has been chosen
    router.afterEach(() => {
      mobileMenuOpen.value = false;
    });

    return { navItems, currentLang, mobileMenuOpen, menuModal, desktopStyle, menuMenuStyle };
  },
};
</script>

<style>
.site-nav {
  z-index: var(--z-overlay);
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid var(--border-subtle);
  transition: background var(--duration-slow) var(--ease-default);
}

.nav-inner {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  max-width: 1200px;
  margin-inline: auto;
}

.dark .site-nav {
  background: rgba(17, 26, 22, 0.88);
}

.nav-controls {
  align-items: center;
}

@media (min-width: 768px) {
  .nav-controls {
    gap: var(--space-4);
  }
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  text-decoration: none;
  color: var(--text-primary);
  transition: opacity var(--duration-fast) var(--ease-default);
}

.nav-logo:hover {
  opacity: 0.7;
}

.nav-logo.router-link-exact-active {
  color: var(--text-primary) !important;
}

.nav-logo__text {
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-wide);
}


@media (min-width: 768px) {
  .nav-logo__text {
    font-size: var(--text-md);
  }
}


</style>
